<template>
    <li class="nav-item nav-profile dropdown">
        <a class="d-flex align-items-center nav-link"
           id="settingsDropdown"
           href="#"
           data-toggle="dropdown"
           aria-expanded="false">
      
            <app-icon :name="'settings'" width="22" height="22"/>
        </a>
        <div class="dropdown-menu dropdown-menu-right navbar-dropdown" aria-labelledby="settingsDropdown">
            <a class="dropdown-item" v-for="(item, index) in data" :href="item.url" :key="index">
                <app-icon class="mr-3" :name="item.optionIcon"/>
                {{ item.optionName }}
            </a>
            <div class="dropdown-divider"/>
            <button class="dropdown-item"
                    type="button"
                    @click.prevent="toggleDarkMode">
                <span v-if="darkMode" :key="'sun'">
                    <app-icon :name="'sun'"/> <span class="ml-2">{{ $t('turn_on_light_mode') }}</span>
                </span>
                <span v-else :key="'moon'">
                    <app-icon :name="'moon'"/> <span class="ml-2">{{ $t('turn_on_dark_mode') }}</span>
                </span>
            </button>
            
            
        </div>
    </li>
</template>

<script>
    import ThemeMixin from "../../../mixins/global/ThemeMixin";
    export default {
        name: "SettingsDropdown",
        mixins: [ThemeMixin],
        props: {
            data: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                darkMode: false,
            }
        },
    }
</script>
